import React from 'react';
import Hero from './components/Hero';
import Nav from './components/Nav';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import GitHubActivity from './components/GitHubActivity';
import Courses from './components/Courses';
import Footer from './components/Footer';
import useReveal from './hooks/useReveal';
import { HighlightProvider } from './context/Highlight';

export default function Portfolio() {
  useReveal();
  return (
    <HighlightProvider>
      <Nav />
      <Hero />
      <Experience />
      <Skills />
      <Projects />
      <GitHubActivity />
      <Courses />
      <Footer />
    </HighlightProvider>
  );
}
